<ul class="nav sidebar-nav" role="tablist" aria-multiselectable="false">
  <div class="mob-profile visible-xs visible-sm">
    <span
      class="mat-ava"
      [ngStyle]="{ background: avatarBackgroundcolor || '#000' }"
      >{{ userProfileAvatar }}</span
    >
    <p [ngClass]="{ 'text-hor': (userFirstName + userLastName).length < 18 }">
      {{ userFirstName }} {{ userLastName }}
    </p>
  </div>

  <li
    routerLinkActive="active"
    class="li-width"
    [routerLinkActiveOptions]="{ exact: true }"
    [appPermission]="COMPONENT_PERMISSION['inscan']"
  >
    <a [routerLink]="['/dashboard/inscan']" (click)="createCheck()"
      ><i class="brick"></i>{{ "sidebar.inscan" | translate }}</a
    >
  </li>

  @if (disableFacilityTab) {
    <li
      routerLinkActive="active"
      class="li-width"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      <a [routerLink]="['/dashboard/facility']" (click)="createCheck()">
        <i class="brick"></i>{{ "sidebar.facility" | translate }}
      </a>
    </li>
  }

  <li
    routerLinkActive="active"
    class="li-width"
    [routerLinkActiveOptions]="{ exact: true }"
    [appPermission]="COMPONENT_PERMISSION['create']"
  >
    <a [routerLink]="['/dashboard/create']" (click)="createCheck()"
      ><i class="brick"></i>{{ "sidebar.create" | translate }}</a
    >
  </li>

  <li
    routerLinkActive="active"
    class="li-width"
    [routerLinkActiveOptions]="{ exact: true }"
    [appPermission]="COMPONENT_PERMISSION['apply-NSL']"
  >
    <a [routerLink]="['/dashboard/apply-NSL']" (click)="createCheck()"
      ><i class="brick"></i>{{ "sidebar.apply-nsl" | translate }}</a
    >
  </li>

  <li
    routerLinkActive="active"
    class="li-width"
    [routerLinkActiveOptions]="{ exact: true }"
    [appPermission]="COMPONENT_PERMISSION['status-check']"
  >
    <a [routerLink]="['/dashboard/status-check']" (click)="createCheck()"
      ><i class="brick"></i>{{ "sidebar.checkStatus" | translate }}</a
    >
  </li>

  <li
    routerLinkActive="active"
    class="li-width"
    [routerLinkActiveOptions]="{ exact: true }"
    [appPermission]="COMPONENT_PERMISSION['manifest']"
  >
    <a (click)="onManifestToggle()"
      ><i class="brick"></i>{{ "sidebar.package" | translate }}</a
    >
  </li>
  @if (isManifestDropdownActive) {
    <li
      mat-menu-item
      routerLinkActive="active"
      class="li-width"
      [routerLinkActiveOptions]="{ exact: true }"
      [appPermission]="COMPONENT_PERMISSION['manifest']"
    >
      <a
        [routerLink]="['/dashboard/manifest']"
        (click)="createCheck()"
        class="a-left-margin"
        ><i class="brick"></i>{{ "sidebar.manifest" | translate }}</a
      >
    </li>
  }
  @if (isManifestDropdownActive) {
    <li
      mat-menu-item
      routerLinkActive="active"
      class="li-width"
      [routerLinkActiveOptions]="{ exact: true }"
      [appPermission]="COMPONENT_PERMISSION['manifest']"
    >
      <a
        [routerLink]="['/dashboard/edit-package']"
        (click)="createCheck()"
        class="a-left-margin"
        ><i class="brick"></i>{{ "sidebar.editPackage" | translate }}</a
      >
    </li>
  }
  @if (isManifestDropdownActive) {
    <li
      mat-menu-item
      routerLinkActive="active"
      class="li-width"
      [routerLinkActiveOptions]="{ exact: true }"
      [appPermission]="COMPONENT_PERMISSION['update-dimension']"
    >
      <a
        [routerLink]="['/dashboard/edit-package-dimensions']"
        (click)="createCheck()"
        class="a-left-margin"
        ><i class="brick"></i>{{ "sidebar.updateDimension" | translate }}</a
      >
    </li>
  }

  @if (
    checkPermissionExist(COMPONENT_PERMISSION["create-pickup"]) ||
    checkPermissionExist(COMPONENT_PERMISSION["fetch-pickup"])
  ) {
    <li class="li-width">
      <a (click)="onPurToggle()"
        ><i class="brick"></i>{{ "sidebar.pickupRequest" | translate }}</a
      >
    </li>
  }
  @if (isPurDropdownActive) {
    <li
      mat-menu-item
      routerLinkActive="active"
      class="li-width"
      [routerLinkActiveOptions]="{ exact: true }"
      [appPermission]="COMPONENT_PERMISSION['create-pickup']"
    >
      <a
        [routerLink]="['/dashboard/create-pickup']"
        (click)="createCheck()"
        class="a-left-margin"
        ><i class="brick"></i>{{ "sidebar.create" | translate }}</a
      >
    </li>
  }
  @if (isPurDropdownActive) {
    <li
      mat-menu-item
      routerLinkActive="active"
      class="li-width"
      [routerLinkActiveOptions]="{ exact: true }"
      [appPermission]="COMPONENT_PERMISSION['fetch-pickup']"
    >
      <a
        [routerLink]="['/dashboard/fetch-pickup']"
        (click)="createCheck()"
        class="a-left-margin"
        ><i class="brick"></i>{{ "serviceability.fetch" | translate }}</a
      >
    </li>
  }

  @if (
    checkPermissionExist(COMPONENT_PERMISSION["document-upload"]) ||
    checkPermissionExist(COMPONENT_PERMISSION["document-download"])
  ) {
    <li class="li-width">
      <a (click)="onToggle()"
        ><i class="brick"></i>{{ "sidebar.document" | translate }}</a
      >
    </li>
  }
  @if (isDropdownActive) {
    <li
      mat-menu-item
      routerLinkActive="active"
      class="li-width"
      [routerLinkActiveOptions]="{ exact: true }"
      [appPermission]="COMPONENT_PERMISSION['document-upload']"
    >
      <a
        [routerLink]="['/dashboard/document-upload']"
        (click)="createCheck()"
        class="a-left-margin"
        ><i class="brick"></i>{{ "sidebar.upload" | translate }}</a
      >
    </li>
  }
  @if (isDropdownActive) {
    <li
      mat-menu-item
      routerLinkActive="active"
      class="li-width"
      [routerLinkActiveOptions]="{ exact: true }"
      [appPermission]="COMPONENT_PERMISSION['document-download']"
    >
      <a
        [routerLink]="['/dashboard/document-download']"
        (click)="createCheck()"
        class="a-left-margin"
        ><i class="brick"></i>{{ "sidebar.download" | translate }}</a
      >
    </li>
  }

  <li
    routerLinkActive="active"
    class="li-width"
    [routerLinkActiveOptions]="{ exact: true }"
    [appPermission]="COMPONENT_PERMISSION['client-onboard']"
  >
    <a [routerLink]="['/dashboard/client-onboard']" (click)="createCheck()"
      ><i class="brick"></i>{{ "sidebar.clientOnboard" | translate }}</a
    >
  </li>

  @if (
    checkPermissionExist(COMPONENT_PERMISSION["seller-onboard"]) ||
    checkPermissionExist(COMPONENT_PERMISSION["fetch-seller"])
  ) {
    <li class="li-width">
      <a (click)="onSellerToggle()"
        ><i class="brick"></i>{{ "sidebar.sellerOnboard" | translate }}</a
      >
    </li>
  }
  @if (isSellerDropdownActive) {
    <li
      mat-menu-item
      routerLinkActive="active"
      class="li-width"
      [routerLinkActiveOptions]="{ exact: true }"
      [appPermission]="COMPONENT_PERMISSION['seller-onboard']"
    >
      <a
        [routerLink]="['/dashboard/seller-onboard']"
        (click)="createCheck()"
        class="a-left-margin"
        ><i class="brick"></i>{{ "sidebar.create" | translate }}</a
      >
    </li>
  }
  @if (isSellerDropdownActive) {
    <li
      mat-menu-item
      routerLinkActive="active"
      class="li-width"
      [routerLinkActiveOptions]="{ exact: true }"
      [appPermission]="COMPONENT_PERMISSION['fetch-seller']"
    >
      <a
        [routerLink]="['/dashboard/fetch-seller']"
        (click)="createCheck()"
        class="a-left-margin"
        ><i class="brick"></i>{{ "serviceability.fetch" | translate }}</a
      >
    </li>
  }

  @if (checkPermissionExist(COMPONENT_PERMISSION["consignee-onboard"])) {
    <li class="li-width">
      <a (click)="onConsigneeToggle()"
        ><i class="brick"></i>{{ "sidebar.consigneeOnboard" | translate }}</a
      >
    </li>
  }
  @if (isConsigneeDropdownActive) {
    <li
      mat-menu-item
      routerLinkActive="active"
      class="li-width"
      [routerLinkActiveOptions]="{ exact: true }"
      [appPermission]="COMPONENT_PERMISSION['consignee-onboard']"
    >
      <a
        [routerLink]="['/dashboard/consignee-onboard']"
        (click)="createCheck()"
        class="a-left-margin"
        ><i class="brick"></i>{{ "sidebar.create" | translate }}</a
      >
    </li>
  }
  <!--
  <li mat-menu-item routerLinkActive="active" *ngIf="isConsigneeDropdownActive" class="li-width" [routerLinkActiveOptions]="{ exact: true }" [appPermission]="COMPONENT_PERMISSION['fetch-consignee']">
    <a [routerLink]="['/dashboard/fetch-consignee']" (click)="createCheck()" class="a-left-margin"><i class="brick"></i>{{ 'serviceability.fetch' | translate }}</a>
  </li>
  -->

  @if (
    checkPermissionExist(COMPONENT_PERMISSION["serviceability"]) ||
    checkPermissionExist(COMPONENT_PERMISSION["fetch-serviceability"])
  ) {
    <li class="li-width">
      <a (click)="onServiceabilityToggle()"
        ><i class="brick"></i>{{ "sidebar.serviceability" | translate }}</a
      >
    </li>
  }
  @if (isServiceabilityDropdownActive) {
    <li
      mat-menu-item
      routerLinkActive="active"
      class="li-width"
      [routerLinkActiveOptions]="{ exact: true }"
      [appPermission]="COMPONENT_PERMISSION['serviceability']"
    >
      <a
        [routerLink]="['/dashboard/serviceability']"
        (click)="createCheck()"
        class="a-left-margin"
        ><i class="brick"></i>{{ "sidebar.create" | translate }}</a
      >
    </li>
  }
  @if (isServiceabilityDropdownActive) {
    <li
      mat-menu-item
      routerLinkActive="active"
      class="li-width"
      [routerLinkActiveOptions]="{ exact: true }"
      [appPermission]="COMPONENT_PERMISSION['fetch-serviceability']"
    >
      <a
        [routerLink]="['/dashboard/fetch-serviceability']"
        (click)="createCheck()"
        class="a-left-margin"
        ><i class="brick"></i>{{ "serviceability.fetch" | translate }}</a
      >
    </li>
  }

  @if (
    checkPermissionExist(COMPONENT_PERMISSION["routing"]) ||
    checkPermissionExist(COMPONENT_PERMISSION["fetch-routing"]) ||
    checkPermissionExist(COMPONENT_PERMISSION["update-routing"])
  ) {
    <li class="li-width">
      <a (click)="onRoutingToggle()"
        ><i class="brick"></i>{{ "sidebar.routing" | translate }}</a
      >
    </li>
  }
  @if (isRoutingDropdownActive) {
    <li
      mat-menu-item
      routerLinkActive="active"
      class="li-width"
      [routerLinkActiveOptions]="{ exact: true }"
      [appPermission]="COMPONENT_PERMISSION['routing']"
    >
      <a
        [routerLink]="['/dashboard/routing']"
        (click)="createCheck()"
        class="a-left-margin"
        ><i class="brick"></i>{{ "sidebar.create" | translate }}</a
      >
    </li>
  }
  @if (isRoutingDropdownActive) {
    <li
      mat-menu-item
      routerLinkActive="active"
      class="li-width"
      [routerLinkActiveOptions]="{ exact: true }"
      [appPermission]="COMPONENT_PERMISSION['update-routing']"
    >
      <a
        [routerLink]="['/dashboard/update-routing']"
        (click)="createCheck()"
        class="a-left-margin"
        ><i class="brick"></i>{{ "sidebar.update" | translate }}</a
      >
    </li>
  }
  @if (isRoutingDropdownActive) {
    <li
      mat-menu-item
      routerLinkActive="active"
      class="li-width"
      [routerLinkActiveOptions]="{ exact: true }"
      [appPermission]="COMPONENT_PERMISSION['fetch-routing']"
    >
      <a
        [routerLink]="['/dashboard/fetch-routing']"
        (click)="createCheck()"
        class="a-left-margin"
        ><i class="brick"></i>{{ "serviceability.fetch" | translate }}</a
      >
    </li>
  }
  <li
    routerLinkActive="active"
    class="li-width"
    [routerLinkActiveOptions]="{ exact: true }"
    [appPermission]="COMPONENT_PERMISSION['handover']"
  >
    <a [routerLink]="['/dashboard/handover']" (click)="createCheck()"
      ><i class="brick"></i>{{ "sidebar.handover" | translate }}</a
    >
  </li>

  @if (disableAmazonSellerInfoTab) {
    <li class="li-width">
      <a (click)="onAmazonSellerToggle()"
        ><i class="brick"></i>{{ "sidebar.amazonSellerInfo" | translate }}</a
      >
    </li>
  }
  @if (disableAmazonSellerInfoTab) {
    <li
      mat-menu-item
      routerLinkActive="active"
      class="li-width"
      [routerLinkActiveOptions]="{ exact: true }"
      [appPermission]="COMPONENT_PERMISSION['fetch_amazon_seller_info']"
    >
      <a
        [routerLink]="['/dashboard/fetch-amazon-seller']"
        (click)="createCheck()"
        class="a-left-margin"
        ><i class="brick"></i>{{ "serviceability.fetch" | translate }}</a
      >
    </li>
  }

  @if (checkPermissionExist(COMPONENT_PERMISSION["create-pickup-pincode"])) {
    <li class="li-width">
      <a (click)="onPickupPincodeToggle()"
        ><i class="brick"></i>{{ "sidebar.pickupPincode" | translate }}</a
      >
    </li>
  }
  @if (isPickupPincodeDropdownActive) {
    <li
      mat-menu-item
      routerLinkActive="active"
      class="li-width"
      [routerLinkActiveOptions]="{ exact: true }"
      [appPermission]="COMPONENT_PERMISSION['create-pickup-pincode']"
    >
      <a
        [routerLink]="['/dashboard/create-pincode']"
        (click)="createCheck()"
        class="a-left-margin"
        ><i class="brick"></i>{{ "sidebar.create" | translate }}</a
      >
    </li>
  }

  <hr class="break-line hr-break-line visible-xs visible-sm" />
  <li
    routerLinkActive="active"
    [routerLinkActiveOptions]="{ exact: true }"
    class="visible-xs visible-sm"
  >
    <a [routerLink]="['/login']" (click)="onLogout()">
      <i class="brick"></i>Logout
    </a>
  </li>

  @if (checkPermissionExist(COMPONENT_PERMISSION["kyc-document-download"])) {
    <li class="li-width">
      <a
        [routerLink]="['/dashboard/kyc-document-download']"
        (click)="createCheck()"
        ><i class="brick"></i>{{ "sidebar.kycDocumentDownload" | translate }}</a
      >
    </li>
  }

  @if (
    checkPermissionExist(COMPONENT_PERMISSION["nae-upload-connections"]) ||
    checkPermissionExist(COMPONENT_PERMISSION["nae-upload-pga"]) ||
    checkPermissionExist(COMPONENT_PERMISSION["nae-upload-lmp"]) ||
    checkPermissionExist(COMPONENT_PERMISSION["nae-audit"])
  ) {
    <li class="li-width">
      <a (click)="onNaeToggle()"
        ><i class="brick"></i>{{ "sidebar.nae" | translate }}</a
      >
    </li>
  }
  @if (
    isNaeDropdownActive &&
    (checkPermissionExist(COMPONENT_PERMISSION["nae-upload-connections"]) ||
      checkPermissionExist(COMPONENT_PERMISSION["nae-upload-pga"]) ||
      checkPermissionExist(COMPONENT_PERMISSION["nae-upload-lmp"]))
  ) {
    <li
      mat-menu-item
      routerLinkActive="active"
      class="li-width"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      <a
        [routerLink]="['/dashboard/nae']"
        (click)="createCheck()"
        class="a-left-margin"
        ><i class="brick"></i>{{ "sidebar.upload" | translate }}</a
      >
    </li>
  }
  @if (
    isNaeDropdownActive &&
    (checkPermissionExist(COMPONENT_PERMISSION["nae-upload-connections"]) ||
      checkPermissionExist(COMPONENT_PERMISSION["nae-upload-pga"]) ||
      checkPermissionExist(COMPONENT_PERMISSION["nae-upload-lmp"]))
  ) {
    <li
      mat-menu-item
      routerLinkActive="active"
      class="li-width"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      <a
        [routerLink]="['/dashboard/nae-status']"
        (click)="createCheck()"
        class="a-left-margin"
        ><i class="brick"></i>{{ "sidebar.status" | translate }}</a
      >
    </li>
  }
  @if (isNaeDropdownActive) {
    <li
      mat-menu-item
      routerLinkActive="active"
      class="li-width"
      [routerLinkActiveOptions]="{ exact: true }"
      [appPermission]="COMPONENT_PERMISSION['nae-audit']"
    >
      <a
        [routerLink]="['/dashboard/nae-audit']"
        (click)="createCheck()"
        class="a-left-margin"
        ><i class="brick"></i>{{ "sidebar.audit" | translate }}</a
      >
    </li>
  }
</ul>
